export default __webpack_public_path__ + "static/media/66.b5922cdd.jpg";